/**
 * Products Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';

export const productsRoutes: RouteRecordRaw[] = [
  {
    path: '/products',
    name: 'products',
    component: () => import('./views/ProductsListView.vue'),
    meta: {
      title: 'Product Management',
      breadcrumbs: [{ label: 'Product Management' }],
      modulePermission: 'productManagement',
    },
  },
  {
    path: '/healthcheck',
    name: 'products-healthcheck',
    component: () => import('../../views/HealthCheckView.vue'),
    meta: {
      title: 'API Health Check',
      breadcrumbs: [
        { label: 'Product Management', to: '/products' },
        { label: 'Health Check' },
      ],
      modulePermission: 'productManagement',
    },
  },
];
